export default "__VITE_ASSET__COhnNy$9__"